import { render } from "./Settlement.vue?vue&type=template&id=1555ef33"
import script from "./Settlement.vue?vue&type=script&lang=js"
export * from "./Settlement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v1/Settlement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1555ef33"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1555ef33', __exports__)) {
    api.reload('1555ef33', __exports__)
  }
  
  module.hot.accept("./Settlement.vue?vue&type=template&id=1555ef33", () => {
    api.rerender('1555ef33', render)
  })

}


export default __exports__